import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from './views/CommonView';
import SBAPI from './util/SBAPI';
import env from '@env';
import { AxiosErrorHandler, isAxiosError } from './util/AxiosErrorHandler';
import { State } from 'vuex-class';
import { Route } from 'vue-router';

@Component({
    components: AllComponents(),
})
export default class App extends Mixins(CommonView) {

    public facebookUrl: string = "";

    public twitterUrl: string = "";

    public lineUrl: string = "";
    public error: string = "";

    @State('error')
    public globalError!: string;

    public async created() {
        await this.getUserAPI();
    }

    @Watch('$route')
    public async routeEvent(to: Route, from: Route) {
        if (this.langEnglish && this.$route.path !== '/mypage/reminder') {
            this.changeLanguage();
        }
    }

    public openLogin: boolean = false;
    public haederOpenLogin() {
        this.openLogin = !this.openLogin;
    }

    public openMenu: boolean = false;
    public haederMenuClick() {
        this.openMenu = !this.openMenu;
    }

    public async logout() {
        let res = await SBAPI.LoginController.logoutUsingDELETE().catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            return;
        }
        await this.getUserAPI();
        this.menuClose();
        this.$router.push("/");
    }

    public menuClose() {
        this.openMenu = false;
    }
}
